import { useQuery } from '@tanstack/react-query';
import { getUserApi } from '../utils/apis';

export const useUser = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['user'],
    queryFn: getUserApi,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const userData = data?.data?.data?.user;
  const isD2Soluser = userData?.email?.endsWith('@yahoo.com') ?? false;

  return {
    user: userData,
    isLoading,
    error,
    isD2Soluser,
  };
};
